import { EPaymentProvider } from '../../../../PaymentWidgetMicrofrontend';

export type TPaymentProcessingState = {
  [key in EPaymentType]?: IPaymentData;
};

export interface IPaymentData {
  status: EPaymentStatus | null;
  paymentId: string;
  provider: EPaymentProvider;
}

export const enum EPaymentType {
  Balance = 'Balance',
  Package = 'Package',
  Publish = 'publish',
}

export const enum EPaymentStatus {
  Pending = 'pending',
  Succeeded = 'succeeded',
  Canceled = 'canceled',
}
